// ============================================================================
// Shared scrolling modal body. The dialog drops its horizontal padding (see
// modal_body.module.scss — in antd v5 that padding sits on `.ant-modal-content`,
// not on the body) so the scroll container spans the full dialog width and the
// scrollbar sits flush against the modal edge. <ModalBody> then insets the
// content itself with its own margin.
//
// Usage: <Modal className={FLUSH_MODAL} bodyStyle={MODAL_BODY_STYLE}>
//          <ModalBody>…</ModalBody>
//        </Modal>
// ============================================================================
import React from "react";
import styles from "./modal_body.module.scss";

export const FLUSH_MODAL = styles.flushModal;

// Pass to Modal's `bodyStyle` (antd 5.8 has no `styles.body` on Modal yet).
export const MODAL_BODY_STYLE: React.CSSProperties = {
  maxHeight: "65vh",
  overflowY: "auto",
  padding: 0,
};

export const ModalBody: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={{ margin: "0 24px" }}>{children}</div>
);

export default ModalBody;
